var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuploLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_16387_113185)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5716 30.1347C14.6546 30.1347 13.0908 28.4116 13.0908 26.2994V18.0915C13.0908 15.9793 14.6546 14.2562 16.5716 14.2562C20.5399 14.2562 23.7852 17.8136 23.7852 22.2047C23.7852 26.5588 20.5399 30.1347 16.5716 30.1347ZM16.5716 15.5532C15.3104 15.5532 14.2679 16.6834 14.2679 18.0915V26.2994C14.2679 27.689 15.2936 28.8377 16.5716 28.8377C19.901 28.8377 22.5914 25.8547 22.5914 22.2047C22.5914 18.5177 19.901 15.5532 16.5716 15.5532Z",
    fill: "#2DB49E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2664 26.063C19.4014 26.063 17.8799 24.3396 17.8799 22.2271V14.0178C17.8799 11.9052 19.4014 10.1819 21.2664 10.1819C25.1273 10.1819 28.2848 13.7398 28.2848 18.1317C28.2684 22.4865 25.1273 26.063 21.2664 26.063ZM21.2664 11.479C20.0394 11.479 19.0251 12.6094 19.0251 14.0178V22.2271C19.0251 23.6169 20.023 24.7658 21.2664 24.7658C24.5056 24.7658 27.1232 21.7823 27.1232 18.1317C27.1232 14.4811 24.4893 11.479 21.2664 11.479Z",
    fill: "#162930"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16387_113185",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DB49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#146E5F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuploLogo);
export default __webpack_public_path__ + "static/media/duploLogo.a9e3d0ce55cc883dbd52b7a5639541bc.svg";
export { ForwardRef as ReactComponent };